import React, { useState } from 'react';
import { Table, Tbody, Td, Th, Thead, Tr,} from "@chakra-ui/react";
import { useTranslation } from 'react-i18next';
import { useNavigate } from "react-router-dom";
import Pagination from "components/ui/pagination/Pagination";

export default function DeliveryZoneDataTable({data}) {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const navigatefunction=(id)=>{
      navigate(`${id}`)
    }
    /* --------------------------------------------- Start Pagination  -----------------------------------------------*/
      const recordsPerPage = 10;
      const [currentPageActive, setCurrentPageActive] = useState(1);
      const prePage = (currentPage, setCurrentPage) => {
        if (currentPage > 1) {
          setCurrentPage(currentPage - 1);
        }
      };
    
      const nextPage = (currentPage, setCurrentPage, npage) => {
        if (currentPage < npage) {
          setCurrentPage(currentPage + 1);
        }
      };
    
      const calculateRecords = (data, currentPage, recordsPerPage) => {
        const firstIndex = (currentPage - 1) * recordsPerPage;
        const lastIndex = Math.min(currentPage * recordsPerPage, data?.length);
        return data?.slice(firstIndex, lastIndex);
      };
    
    // Calculate records for activeDiscounts
    const deliveryZoneData = calculateRecords(
        data,
        currentPageActive,
        recordsPerPage
      );
 /* --------------------------------------------- End Pagination  -----------------------------------------------*/
  return <>
    <>
    <Table>
        <Thead>
                <Tr>
                    <Th>{t("pages.categories.name")}</Th>
                    <Th>{t("pages.categories.name_localized")}</Th>
                    <Th>{t("pages.DeliverZone.refrance")}</Th>
                    <Th>{t("pages.DeliverZone.created")}</Th>
                </Tr>
        </Thead>
        <Tbody>
            {
            deliveryZoneData?.map((item, index) => (
                <Tr key={index}>  
                    <Td  onClick={()=>navigatefunction(item?.DeliveryZoneId)} >{item?.DeliveryZoneName}</Td>
                    <Td>{item?.DeliveryZoneNameLoc}</Td>
                    <Td>{item?.RefCode}</Td>
                    <Td>{item?.Created}</Td>
                </Tr>
            ))
            }
        </Tbody>
    </Table>
    <Pagination
           currentPage={currentPageActive}
            setCurrentPage={setCurrentPageActive}
            npage={Math.ceil(data?.length / recordsPerPage)}
            prePage={() => prePage(currentPageActive, setCurrentPageActive)}
            nextPage={() =>
              nextPage(
                currentPageActive,
                setCurrentPageActive,
                Math.ceil(data?.length / recordsPerPage)
                )
              }
        />
    </>

  </>
};
